import { DateUtils } from '../../../common/utils/DateUtils';
import { BatchExport } from '../models/BatchExport';

export class BatchExportMapper {
  mapExport(data: any): BatchExport {
    return new BatchExport(
      data.exportType,
      data.status,
      data.totalCount,
      data.exportedCount,
      DateUtils.toMoment(data.createdAt),
      data.updatedAt ? DateUtils.toMoment(data.updatedAt) : null
    );
  }

  mapExports(exports: any): BatchExport[] {
    return exports.map((singleExport: any) => {
      return this.mapExport(singleExport);
    });
  }
}
